import { http } from '@martech-solution/utils/utils';
import { IUser, IUserAssignment, UserAdd, UserAssignmentAdd } from 'src/types/master_data/user.type';
import { PagedList } from 'src/types/pagedList.type';

const controller = 'master-data/users';

export const getUsers = async (page: number, pageSize: number, orderBy?: string, searchCondition?: string) => {
  return await http.get<PagedList<IUser>>(controller, {
    params: {
      searchCondition,
      page,
      pageSize,
      orderBy
    }
  });
};

export const getUserById = async (id: number | undefined) => {
  return http.get<IUser>(`${controller}/${id}`);
};

export const getUserAssignments = async (userId: number | undefined) => {
  return http.get<IUserAssignment[]>(`${controller}/assignments/${userId}`);
};

export const addUser = async (user: UserAdd) => {
  return http.post<number>(controller, user);
};

export const addAssignment = async (userAssignment: UserAssignmentAdd) => {
  return http.post<number>(`${controller}/assignments`, userAssignment);
};

export const updateUser = async (id: number, user: IUser) => {
  return await http.put<IUser[]>(`${controller}/${id}`, user);
};

export const deleteUser = async (id: number) => {
  return await http.delete(`${controller}/${id}`);
};

export const checkAdmin = async () => {
  return http.get<boolean>(`${controller}/check-admin`);
};
